import React from 'react';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'full' | 'icon';
}

const Logo: React.FC<LogoProps> = ({ 
  className = '', 
  size = 'md',
  variant = 'full' 
}) => {
  const sizeClasses = {
    sm: 'w-20 h-7',
    md: 'w-32 h-10',
    lg: 'w-40 h-12'
  };

  if (variant === 'icon') {
    return (
      <div className={`${sizeClasses[size]} ${className}`}>
        <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          {/* Background circle */}
          <circle cx="20" cy="20" r="18" fill="#007ad9" stroke="#0056b3" strokeWidth="2"/>
          
          {/* AI/Data visualization icon */}
          <g transform="translate(8, 8)">
            {/* Neural network nodes */}
            <circle cx="6" cy="4" r="2" fill="white"/>
            <circle cx="18" cy="4" r="2" fill="white"/>
            <circle cx="6" cy="20" r="2" fill="white"/>
            <circle cx="18" cy="20" r="2" fill="white"/>
            <circle cx="12" cy="12" r="2.5" fill="white"/>
            
            {/* Connections */}
            <line x1="6" y1="4" x2="12" y2="12" stroke="white" strokeWidth="1.5" opacity="0.8"/>
            <line x1="18" y1="4" x2="12" y2="12" stroke="white" strokeWidth="1.5" opacity="0.8"/>
            <line x1="6" y1="20" x2="12" y2="12" stroke="white" strokeWidth="1.5" opacity="0.8"/>
            <line x1="18" y1="20" x2="12" y2="12" stroke="white" strokeWidth="1.5" opacity="0.8"/>
            
            {/* Data flow arrows */}
            <path d="M2 12 L6 10 L6 14 Z" fill="white" opacity="0.9"/>
            <path d="M22 12 L18 10 L18 14 Z" fill="white" opacity="0.9"/>
          </g>
        </svg>
      </div>
    );
  }

  return (
    <div className={`${sizeClasses[size]} ${className}`}>
      <svg viewBox="0 0 120 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        {/* Background circle */}
        <circle cx="20" cy="20" r="18" fill="#007ad9" stroke="#0056b3" strokeWidth="2"/>
        
        {/* AI/Data visualization icon */}
        <g transform="translate(8, 8)">
          {/* Neural network nodes */}
          <circle cx="6" cy="4" r="2" fill="white"/>
          <circle cx="18" cy="4" r="2" fill="white"/>
          <circle cx="6" cy="20" r="2" fill="white"/>
          <circle cx="18" cy="20" r="2" fill="white"/>
          <circle cx="12" cy="12" r="2.5" fill="white"/>
          
          {/* Connections */}
          <line x1="6" y1="4" x2="12" y2="12" stroke="white" strokeWidth="1.5" opacity="0.8"/>
          <line x1="18" y1="4" x2="12" y2="12" stroke="white" strokeWidth="1.5" opacity="0.8"/>
          <line x1="6" y1="20" x2="12" y2="12" stroke="white" strokeWidth="1.5" opacity="0.8"/>
          <line x1="18" y1="20" x2="12" y2="12" stroke="white" strokeWidth="1.5" opacity="0.8"/>
          
          {/* Data flow arrows */}
          <path d="M2 12 L6 10 L6 14 Z" fill="white" opacity="0.9"/>
          <path d="M22 12 L18 10 L18 14 Z" fill="white" opacity="0.9"/>
        </g>
        
        {/* Company name */}
        <text x="48" y="16" fontFamily="Inter, system-ui, sans-serif" fontSize="14" fontWeight="700" fill="#1f2937">
          Insights
        </text>
        <text x="48" y="30" fontFamily="Inter, system-ui, sans-serif" fontSize="12" fontWeight="500" fill="#6b7280">
          Research
        </text>
      </svg>
    </div>
  );
};

export default Logo;